import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchUserProfile } from "../../../services/profileService";
import { setUser } from "../../../redux/userSlice";
import Sidebar from "../../../components/Sidebar";
import FirstTimeUserHome from "./FirstTimeUserHome";
import ExistingUserNoQuizHome from "./ExistingUserNoQuizHome";
import ExistingUserNoCareerHome from "./ExistingUserNoCareerHome";
import ExistingUserNoPathwayHome from "./ExistingUserNoPathwayHome";
import ExistingUserWithPathwayHome from "./ExistingUserWithPathwayHome";

const Home = () => {
  const [userState, setUserState] = useState("first-time");
  const dispatch = useDispatch();
  const { id: userId } = useSelector((state) => state.auth);
  const { targetJob, currentJob, quizCompleted, totalScore, hasPathway, hasAIJobImpact } = useSelector((state) => state.user);

  useEffect(() => {
    const fetchUserData = async () => {
      if (!userId) return;
      
      if (currentJob || targetJob || quizCompleted || totalScore > 0 || hasPathway || hasAIJobImpact) {
        return;
      }
      
      try {
        const { data } = await fetchUserProfile(userId);
        dispatch(setUser(data));
      } catch (error) {
        console.error("Error fetching user profile:", error);
      }
    };

    fetchUserData();
  }, [userId, dispatch, currentJob, targetJob, quizCompleted, totalScore, hasPathway, hasAIJobImpact]);

  useEffect(() => {
    const determineUserState = async () => {
      if (!userId) return;

      try {
        if (!hasAIJobImpact) {
          setUserState("first-time");
        } else if (!targetJob) {
          setUserState("existing-user-no-career");
        } else if (!quizCompleted && hasPathway) {
          setUserState("existing-user-with-pathway");
        } else if (!quizCompleted) {
          setUserState("existing-user-no-quiz");
        } else if (!hasPathway) {
          setUserState("existing-user-no-pathway");
        } else {
          setUserState("existing-user-with-pathway");
        }
      } catch (error) {
        console.error("Error determining user state:", error);
      }
    };

    determineUserState();
  }, [userId, hasAIJobImpact, targetJob, quizCompleted, hasPathway]);

  // Refetch user data when returning to the page (e.g., from AI Job Impact Assessment)
  useEffect(() => {
    const handleFocus = async () => {
      if (!userId) return;
      
      try {
        const { data } = await fetchUserProfile(userId);
        dispatch(setUser(data));
      } catch (error) {
        console.error("Error refetching user profile:", error);
      }
    };

    window.addEventListener('focus', handleFocus);
    return () => window.removeEventListener('focus', handleFocus);
  }, [userId, dispatch]);

  const renderHomePage = () => {
    const components = {
      "first-time": <FirstTimeUserHome />,
      "existing-user-no-quiz": <ExistingUserNoQuizHome />,
      "existing-user-no-career": <ExistingUserNoCareerHome />,
      "existing-user-no-pathway": <ExistingUserNoPathwayHome />,
      "existing-user-with-pathway": <ExistingUserWithPathwayHome />,
      "loading": (
        <div className="flex items-center justify-center min-h-screen">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div>
        </div>
      )
    };

    return components[userState];
  };

  return (
    <Sidebar>
      {renderHomePage()}
    </Sidebar>
  );
};

export default Home; 